import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { baseBody } from "../SuggestionBody.styles";

export const container: CSSProperties = {
  ...baseBody,
  marginTop: -10,
  paddingTop: 0,
  paddingLeft: 6,
  backgroundColor: "none",
  display: "flex",
  alignItems: "center",
};

export const smallIcon: CSSProperties = {
  width: 24,
  height: 24,
};

export const smallBtn: CSSProperties = {
  width: 32,
  height: 32,
  padding: 2,
  cursor: "default",
};

export const moreSettingsLink: CSSProperties = {
  marginLeft: "auto",
  fontSize: 12,
};
